import { render, staticRenderFns } from "./DefaultAside.vue?vue&type=template&id=a01f78f2"
import script from "./DefaultAside.vue?vue&type=script&lang=js"
export * from "./DefaultAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a01f78f2')) {
      api.createRecord('a01f78f2', component.options)
    } else {
      api.reload('a01f78f2', component.options)
    }
    module.hot.accept("./DefaultAside.vue?vue&type=template&id=a01f78f2", function () {
      api.rerender('a01f78f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/views/layouts/partials/DefaultAside.vue"
export default component.exports